module.exports = __webpack_public_path__ + "img/caseBuilder-aeronautical.705f374b.webp";